<template>
    <div>
        <SimpleTable
            :flat="true"
            title="Ventas"
            subtitle="Listado de ventas realizadas"
            :columns="columns"
            :data="tableData"
            :skeleton-rows="5"
            :empty-text="'No hay ventas'"
            :default-col-width="defaultColWidth"
        >
            <template #cell-metodo_pago="{ value }">
                {{ filters.formatear_metodo_pago(value) }}
            </template>
            <template #cell-plazo="{ value }">
                <i
                    v-if="value"
                    class="text-green fas fa-check-circle tw:text-lg"
                ></i>
                <i
                    v-else
                    class="text-danger fas fa-times-circle tw:text-lg"
                ></i>
            </template>
            <template #cell-importe="{ value }">
                {{ formatPrice(value) }}
            </template>
            <template #footer>
                <tr class="tw:bg-gray-50">
                    <td colspan="7" class="tw:px-6 tw:py-3 tw:font-semibold">TOTAL</td>
                    <td class="tw:px-6 tw:py-3 tw:font-semibold">{{ formatPrice(totalImporte) }}</td>
                </tr>
            </template>
        </SimpleTable>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue';
    import filters from '@/filters';

    const props = defineProps({
        informe: { type: Array, default: () => [] },
        detalle: { type: Array, default: null },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    });

    const columns = [
        { key: 'tpv_order', label: 'Nº pedido', class: 'tw:w-36' },
        { key: 'categoria', label: 'Categoría' },
        { key: 'nombre', label: 'Nombre' },
        { key: 'apellidos', label: 'Apellidos', class: 'tw:w-44' },
        { key: 'metodo_pago', label: 'Método de pago' },
        { key: 'plazo', label: 'Pago plazos', centered: true },
        { key: 'fecha', label: 'Fecha' },
        { key: 'importe', label: 'Importe' }
    ];

    const tableData = computed(() => {
        if (props.detalle && props.detalle.length) return props.detalle;
        if (props.informe && props.informe.length) return props.informe;
        return [];
    });

    const totalImporte = computed(() => {
        return tableData.value.reduce((sum, row) => {
            return sum + (Number(row.importe) || 0);
        }, 0);
    });

    const formatPrice = filters.formatear_precio;

    function formatDate(value) {
        if (!value) return '-';
        try {
            return new Date(value).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
        } catch { return value; }
    }
</script>
